import React from 'react';
import { theme } from '@fiverr-private/theme';
import { L1_ICON_SIZES } from '../../constants';
import type { L1IconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const SpinnerL1Icon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('SpinnerL1Icon'),
}: L1IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L1_ICON_SIZES[size]}
    height={L1_ICON_SIZES[size]}
    viewBox="0 0 32 32"
    data-track-tag={dataTrackTag}
    fill={theme.colors[color]}
  >
    <path d="M16 0a16 16 0 0 0 0 32 16 16 0 0 0 0-32m0 4a12 12 0 0 1 0 24 12 12 0 0 1 0-24" opacity={0.18} />
    <path d="M16 0a16 16 0 0 1 16 16h-4A12 12 0 0 0 16 4z">
      <animateTransform
        attributeName="transform"
        dur="0.8s"
        from="0 16 16"
        repeatCount="indefinite"
        to="360 16 16"
        type="rotate"
      />
    </path>
  </svg>
);
SpinnerL1Icon.displayName = 'SpinnerL1Icon';
export default SpinnerL1Icon;
